import React from 'react';

export function PodGridItem(props: React.PropsWithChildren<any>) {

	return (
		<div className='pods-benefits-grid-item'>
			{props.children}
		</div>
	);
}